export const getAnonymousId = (): string => {
  let anonymousId = document.cookie.split('; ').find((row) => row.startsWith('anonymousId='))?.split('=')[1];
  if (anonymousId) {
    anonymousId = decodeURIComponent(anonymousId);
    const match = anonymousId.match(
      /([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/i,
    );
    anonymousId = match?.[1];
  }
  return anonymousId || '';
};
